import { makeObservable } from "mobx";
import { BaseSyncModelStore } from "@/store/sync/BaseSyncModelStore";
import { SyncModelKind, type SyncUpdateValue } from "@/store/sync/types";
import type { AppSubStoreArgs } from "@/store/types";
import type { SpaceAccountConnectionModelData } from "@/store/connections/types";
import { SpaceAccountConnectionObservable } from "@/store/connections/SpaceAccountConnectionObservable";

export class AppStoreSpaceAccountConnectionsStore extends BaseSyncModelStore<
  SpaceAccountConnectionObservable,
  SpaceAccountConnectionModelData
> {
  constructor(injectedDeps: AppSubStoreArgs) {
    super({ modelKind: SyncModelKind.SpaceAccountConnection, ...injectedDeps });
    makeObservable(this, { createSyncModel: false });
  }

  createSyncModel(
    data: SyncUpdateValue<SpaceAccountConnectionModelData>
  ): SpaceAccountConnectionObservable {
    return new SpaceAccountConnectionObservable({
      id: data.model_id,
      data,
      store: this.store,
    });
  }
}
